var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "IaPainelLateral",
    {
      attrs: {
        aberto: _vm.aberto,
        titulo: "Especialista em Fee Fixo",
        subtitulo: _vm.rotuloContexto,
        "rotulo-aba": "Especialista"
      },
      on: { abrir: _vm.abrir, fechar: _vm.fechar },
      scopedSlots: _vm._u([
        {
          key: "acoes",
          fn: function() {
            return [
              _c(
                "button",
                {
                  staticClass: "ia-painel-lateral__botao",
                  attrs: {
                    type: "button",
                    "aria-label": "Nova conversa",
                    title: "Nova conversa",
                    disabled: _vm.carregando
                  },
                  on: { click: _vm.novaConversa }
                },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: "add-circle",
                      size: 18,
                      color: "var(--neutral-700)"
                    }
                  })
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "div",
        { staticClass: "ff-ia-conteudo" },
        [
          _c(
            "div",
            { ref: "listaMensagens", staticClass: "ff-ia-mensagens" },
            [
              _vm.semMensagens
                ? _c("EmptyMessages", {
                    staticClass: "ff-ia-vazio",
                    attrs: {
                      headline: "Vamos falar sobre este cliente?",
                      sugestoes: _vm.sugestoes
                    },
                    on: { "use-suggestion": _vm.usarSugestao },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "descricao",
                          fn: function() {
                            return [
                              _c(
                                "p",
                                { staticClass: "az-text-secondary mb-0" },
                                [
                                  _vm._v(
                                    " Tire dúvidas de conta e de argumento sem sair da tela. Os números vêm do diagnóstico salvo do cliente — quando não há cenário salvo, o agente diz isso em vez de estimar. "
                                  )
                                ]
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      3235549123
                    )
                  })
                : _vm._e(),
              _vm._l(_vm.mensagensParaExibir, function(msg, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    class: [
                      "ff-ia-msg",
                      msg.role === "user"
                        ? "ff-ia-msg--usuario"
                        : "ff-ia-msg--agente"
                    ]
                  },
                  [
                    msg.role === "user"
                      ? _c("div", [_vm._v(_vm._s(msg.content))])
                      : _c("AawzMarkdownRender", {
                          attrs: { source: msg.content }
                        }),
                    msg.itensAnexosPersistidos &&
                    msg.itensAnexosPersistidos.length
                      ? _c("ComposerAttachments", {
                          staticClass: "ff-ia-anexos",
                          attrs: {
                            "somente-leitura": "",
                            arquivos: msg.itensAnexosPersistidos
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              }),
              _vm.carregando
                ? _c(
                    "div",
                    { staticClass: "ff-ia-msg ff-ia-msg--agente" },
                    [
                      _vm.ferramentasEmUso.length
                        ? _c("div", { staticClass: "ff-ia-ferramenta" }, [
                            _vm._v(" Consultando o diagnóstico… ")
                          ])
                        : _vm._e(),
                      _vm.respostaEmCurso
                        ? _c("AawzMarkdownRender", {
                            attrs: { source: _vm.respostaEmCurso }
                          })
                        : _vm._e(),
                      _c("icon-svg", {
                        staticClass: "ff-ia-pensando",
                        attrs: {
                          name: "ia-w-mark",
                          size: 20,
                          color: "var(--aawz-green-color)",
                          animated: ""
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("PartesDoTurno", {
                staticClass: "ff-ia-partes mt-3",
                attrs: {
                  partes: _vm.partesDoTurno,
                  "ultima-mensagem": _vm.ultimaMensagemDoAgente,
                  "chaves-ignoradas": _vm.chavesDesenhadasPelaTela,
                  "store-module": "feeFixoIa"
                }
              }),
              _c(
                "v-fade-transition",
                [
                  _vm.simulacaoPendente
                    ? _c("FeeFixoGuiaSimulacaoCard", {
                        staticClass: "ff-ia-simulacao mt-3",
                        attrs: {
                          inputs: _vm.simulacaoPendente.inputs,
                          "premissas-declaradas":
                            _vm.simulacaoPendente.premissasDeclaradas,
                          "preview-id": _vm.simulacaoPendente.previewId,
                          processando: _vm.salvandoSimulacao || _vm.carregando,
                          "aviso-carteira-pendente":
                            _vm.simulacaoPendente.avisoCarteiraPendente,
                          "erro-deposito": _vm.erroDoDepositoDaSimulacao
                        },
                        on: {
                          confirmar: _vm.confirmarSimulacao,
                          cancelar: _vm.cancelarSimulacao,
                          redepositar: _vm.redepositarSimulacao
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-fade-transition",
                [
                  _vm.previewEnvio
                    ? _c("FeeFixoIaEnvioRelatorio", {
                        staticClass: "ff-ia-envio mt-3",
                        attrs: {
                          preview: _vm.previewEnvio,
                          etapa: _vm.envioEtapa,
                          resolvido: _vm.envioResolvido,
                          "mensagem-erro": _vm.envioErro,
                          resultado: _vm.envioResultado
                        },
                        on: {
                          enviar: _vm.enviarRelatorio,
                          cancelar: _vm.cancelarEnvio,
                          fechar: _vm.cancelarEnvio
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            2
          ),
          _c("SendMessage", {
            attrs: {
              value: _vm.mensagem,
              loading: _vm.carregando,
              placeholder: _vm.placeholderDoComposer,
              "store-module": "feeFixoIa",
              "show-attachments": "",
              "anexos-liberados": "",
              "id-cliente-anexo": _vm.idClienteAnexo,
              "hide-disclaimer": ""
            },
            on: {
              input: _vm.aoDigitar,
              send: _vm.enviarDigitado,
              abort: _vm.cancelar
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }